// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__B0hE7","eventsList":"Dashboard_eventsList__hGA26","eventItem":"Dashboard_eventItem__nFlNP","error":"Dashboard_error__zxfYk"};